var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-group", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var ariaDescribedby = ref.ariaDescribedby
          return [
            _c("b-form-radio-group", {
              staticClass: "scroll align-items-center",
              attrs: {
                id: "btn-radios-2",
                options: _vm.options,
                "aria-describedby": ariaDescribedby,
                size: "lg",
                buttons: ""
              },
              model: {
                value: _vm.selection,
                callback: function($$v) {
                  _vm.selection = $$v
                },
                expression: "selection"
              }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }